export default __webpack_public_path__ + "static/media/nl.2df377c1.svg";